import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useRole } from "@/hooks/useRole";
import { Loader2 } from "lucide-react";

// Import Player Panel pages
import MentoriasCompradas from "./player/MentoriasCompradas";
import MinhasComunidades from "./player/MinhasComunidades";
import MeusConteudos from "./player/MeusConteudos";
import Pagamentos from "./player/Pagamentos";
import Perfil from "./player/Perfil";
import PlayerChat from "./player/PlayerChat";
import { AccessDenied } from "@/components/admin/games/AccessDenied";
import { PlayerSidebar } from "@/components/player/PlayerSidebar";

const PlayerPanel = () => {
  const { role, loading } = useRole();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0f141c] pt-16">
        <Loader2 className="h-12 w-12 text-[#00B6F0] animate-spin" />
      </div>
    );
  }

  // Só redireciona se não está carregando E o role não é jogador
  // Isso evita redirecionamento durante o carregamento inicial
  if (!loading && role !== "jogador") {
    return <AccessDenied />;
  }

  return (
    <div className="min-h-screen bg-[#0f141c]">
      <div className="flex">
        <PlayerSidebar />
        <div className="flex-1 transition-all duration-300 pt-8 pb-8 p-6">
          <Routes>
            {/* Redireciona a rota raiz para perfil */}
            <Route path="/" element={<Navigate to="/painel-jogador/perfil" replace />} />
            <Route path="/mentorias-compradas" element={<MentoriasCompradas />} />
            <Route path="/meus-conteudos" element={<MeusConteudos />} />
            <Route path="/minhas-comunidades" element={<MinhasComunidades />} />
            <Route path="/chat" element={<PlayerChat />} />
            <Route path="/chat/:conversationId" element={<PlayerChat />} />
            <Route path="/pagamentos" element={<Pagamentos />} />
            <Route path="/perfil" element={<Perfil />} />
            <Route path="*" element={<Navigate to="/painel-jogador" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default PlayerPanel;
